import algoliasearch from 'algoliasearch';

export const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID!,
  process.env.REACT_APP_ALGOLIA_API_KEY!
);

export interface IProduct {
  id: string;
  created?: Date;
  product_id: string;
  vendor_id: string;
  available_countries: Array<string>;
  categories: Array<string>;
  coupon_code_available: boolean;
  coupon_code_locations: Array<string>;
  is_shipping_required?: boolean;
  num_of_purchase?: number;
  product_instruction_image: Array<string>;
  product_image_url: string;
  product_title: string;
  product_name?: string;
  subcategories: Array<string>;
  vendor_title: string;
  vendor_subtitle: string;
  term: string;
  usd_special_price: number;
  usd_msrp: number;
  variations?: {
    options: {
      [key: string]: {
        label: string;
        values: Array<string>;
      };
    };
    products: Array<{
      id: string;
      options: {
        [key: string]: string;
      };
    }>;
  };
  vendor_logo_url?: string;
  is_vendor_active: boolean;
}

export interface IVendorProduct {
  categories: Array<string>;
  checkout?: {
    is_subscription: boolean;
    shipping_required: boolean;
    sponsored_amount: number;
  };
  description: string;
  digital_app_display?: {
    banner_image_url: string;
    icon_image_url: string;
    platforms: Array<string>;
    description: string;
    callouts: Array<{
      title: string;
      description: string;
      image_url: string;
    }>;
    highlights: Array<string>;
  };
  eligible_wallet_configuration_ids: Array<string>;
  eligible_wallets: Array<string>;
  external_checkout_url?: string;
  how_to_access?: Array<{
    instruction: string;
    instruction_image?: string;
  }>;
  id: string;
  instruction_image?: Array<string>;
  is_inactive: boolean;
  is_sales_tax_required: boolean;
  msrp: number;
  name?: string;
  shipping_required: boolean;
  special_price: number;
  subcategories: Array<string>;
  tags: Array<string>;
  term: string;
  title: string;
  options?: {
    [key: string]: string;
  };
  variations?: {
    options: {
      [key: string]: {
        label: string;
        values: Array<string>;
      };
    };
    products: Array<{
      id: string;
      options: {
        [key: string]: string;
      };
    }>;
  };
}

export interface IVendor {
  categories: Array<string>;
  code_name: string;
  cancellation_refund?: string;
  coupon_code_available: boolean;
  coupon_code_locations: Array<string>;
  description: string;
  faqs?: Array<{
    q: string;
    a: string;
  }>;
  id: string;
  image_url: string;
  internal_tags: Array<string>;
  is_checkout_enabled: boolean;
  name: string;
  pricing_plan_available: boolean;
  product_list: Array<IVendorProduct>;
  proration_allowed: boolean;
  special_terms?: string;
  subcategories: Array<string>;
  subtitle: string;
  title: string;
  type: string;
  website_url: string;
  what_to_expect?: string;
}
